import { render } from "./TrueOrFalseQuestion.vue?vue&type=template&id=163dba8e&scoped=true&ts=true"
import script from "./TrueOrFalseQuestion.vue?vue&type=script&lang=ts"
export * from "./TrueOrFalseQuestion.vue?vue&type=script&lang=ts"

import "./style.scss?vue&type=style&index=0&id=163dba8e&lang=scss&scoped=true"
import "./TrueOrFalseQuestion.vue?vue&type=style&index=1&id=163dba8e&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/deployJob/project/music-teach/h5-internal-examination/code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-163dba8e"]])

export default __exports__